.UnderlineWrapper {
  /* Progressive enhancement: Detect overflow using scroll-based animations.
  The idiomatic way would be a scroll-state container query but browser support
  is slightly better for animations. */
  animation: detect-overflow linear;
  animation-timeline: scroll(self block);
  container-type: inline-size;

  --UnderlineNav_moreButton-display: none;

  &[data-has-overflow='true'] {
    --UnderlineNav_moreButton-display: flex;
  }
}

/* Set overflow button visibility with pure CSS to avoid a layout shift on hydration */
@keyframes detect-overflow {
  0%,
  100% {
    --UnderlineNav_moreButton-display: flex;
  }
}

.UnderlineWrapper[data-hide-icons-breakpoint='xsmall'] {
  @container (width < 20rem) {
    .ItemsList [data-component='icon'] {
      display: none;
    }
  }
}

.UnderlineWrapper[data-hide-icons-breakpoint='small'] {
  @container (width < 34rem) {
    .ItemsList [data-component='icon'] {
      display: none;
    }
  }
}

.UnderlineWrapper[data-hide-icons-breakpoint='medium'] {
  @container (width < 48rem) {
    .ItemsList [data-component='icon'] {
      display: none;
    }
  }
}

.UnderlineWrapper[data-hide-icons-breakpoint='large'] {
  @container (width < 63.25rem) {
    .ItemsList [data-component='icon'] {
      display: none;
    }
  }
}

.UnderlineWrapper[data-hide-icons-breakpoint='xlarge'] {
  @container (width < 80rem) {
    .ItemsList [data-component='icon'] {
      display: none;
    }
  }
}

.UnderlineWrapper[data-hide-icons-breakpoint='xxlarge'] {
  @container (width < 87.5rem) {
    .ItemsList [data-component='icon'] {
      display: none;
    }
  }
}

.WrapSpacer {
  /* Cancel out the flex gap so the first real item has no leading gap */
  /* stylelint-disable-next-line primer/spacing -- negative margin required to cancel the flex gap from the list */
  margin-inline-end: calc(-1 * var(--stack-gap-condensed));
}

.MoreButtonContainer {
  display: var(--UnderlineNav_moreButton-display, flex);
  align-items: center;
}

.OverflowMenuItem [aria-current] {
  position: relative;

  .OverflowMenuItemLabel {
    font-weight: var(--base-text-weight-semibold);
  }

  &::after {
    content: '';
    width: var(--base-size-2);
    position: absolute;
    inset: var(--base-size-2) auto var(--base-size-2) 0;
    /* stylelint-disable-next-line primer/colors */
    background: var(--underlineNav-borderColor-active);
  }
}

.MoreButtonDivider {
  display: inline-block;
  border-left: var(--borderWidth-thin) solid var(--borderColor-muted);
  width: 0;
  margin-inline: var(--base-size-4);
  height: var(--base-size-24);
}

.MoreButton {
  margin: 0; /* reset Safari extra margin */
  font-weight: var(--base-text-weight-normal);
  position: relative;

  & > [data-component='trailingVisual'] {
    margin-left: 0;
  }

  /* When the current item has overflowed into the menu, style the overflow
   anchor so it looks like the current item (semibold text + active underline). */
  &[data-current='true'] {
    font-weight: var(--base-text-weight-semibold);

    &::after {
      position: absolute;
      inset: auto 0 0;
      /* Pull down same amount as the item-level decoration, plus the border width of the button */
      /* stylelint-disable-next-line primer/spacing */
      margin-bottom: calc(-1 * (var(--base-size-8) + var(--borderWidth-thin)));
      height: 2px;
      pointer-events: none;
      content: '';
      /* stylelint-disable-next-line primer/colors */
      background-color: var(--underlineNav-borderColor-active, var(--color-primer-border-active, #fd8c73));

      @media (forced-colors: active) {
        /* Support for Windows Forced Color Mode https://learn.microsoft.com/en-us/fluent-ui/web-components/design-system/high-contrast */
        background-color: LinkText;
      }
    }
  }
}
